import { combineEpics } from 'redux-observable';
import pageReady from './page-ready/index.tsx';
import queryChanged from './query-changed/index.tsx';
import retrieveBoards from './retrieve-boards/index.tsx';

export default combineEpics(queryChanged, retrieveBoards, pageReady);
